<template>
   <div class="progress-sidebar">
      <h4 class="title">{{ title }}</h4>

      <slot></slot>
   </div>
</template>

<script>
export default {
  name: 'ProgressSidebar',
  props: {
    title: String
  }
};
</script>

<style lang="scss">
.progress-sidebar {
	> .title {
		font-size: 21px;
		font-weight: 700;
		color: #000;
	}
}
</style>
